/* eslint-disable no-unused-vars */
import { Env } from "types/Env"

import { typifyEnv } from "./utils"

/* eslint-disable @typescript-eslint/no-unused-vars */
export const CLIENT_ID = "electron"
export const REDIRECT_URL = "http://localhost:38540"

export * from "static/misc/constants"

const env = typifyEnv({
  ...(process.env || {}),
  ...(process.customEnv || {}),
} as NodeJS.Process["env"] & Env<true>)

export const {
  API_ENV,
  ENDPOINT_S3,
  APP_ID,
  NO_ADMIN_RIGHTS,
  PATH_S3,
  BUCKET_S3,
  ELECTRON_WEBPACK_WDS_PORT,
  LOKALIZE_API_TOKEN,
  LOKALIZE_PROJECT_ID,
  BACKOFFICE_URL,
  TESTWE_API,
  PROCTOR_API,
  APP_NAME,
  NODE_ENV,
  PROCESS_WHITELIST,
  FORCE_LANGUAGE,
  PORT,
  SPREADJS_LISCENCE_KEY_V18,
  SPREADJS_DESIGNER_COMPONENT_KEY_V18,
  IS_PREVIEW,
  IS_WEB,
  IS_DESKTOP,
  QUICK_EXAM_DEV_MODE,
  DEBUG_PROCESS_KILLER,
  ALLOW_DEV_TOOLS,
  ANTICHEAT_NO_VM_CHECK,
  ANTICHEAT_NO_SHORTCUT_LIMITATION,
  ANTICHEAT_NO_REFOCUS,
  NO_UPDATE_CHECK,
  SECURITY_BINARY_PATH,
  TEST_ENV,
  TEST_DLL_PATH,
  TEST_ELECTRON_PATH,
  TEST_APP_PATH,
  TEST_E2E,
  TEST_APP_TYPE,
  TEST_E2E_USER_DATA_DIR,
  TEST_E2E_APP_DATA_DIR,
  TEST_E2E_SSO_DEEPLINK_PROTOCOL,
} = env

export const VERSION = process.customEnv?.VERSION || env.VERSION

export const APPDATA = TEST_E2E_APP_DATA_DIR || process.env.APPDATA || process.env.HOME || "/tmp"

export const ENV = NODE_ENV

export const TESTWE_COLOR = "#1d39c4"

export const MACOS = "darwin"
export const LINUX = "linux"
export const WINDOWS = "win32"

export const PROTECTION_TIMER = 10000
export const CHEATING_TIMER = 8000
export const MINUTE_TIMER = 60000
export const FKILL_TIMER = 30000
export const FKILL_ATTEMPT = 10

export const CLEAN_LOGS_ARCHIVE_AFTER_DAYS = 90

export const SSO_CALLBACK_BROADCAST_CHANNEL = "tw-app-channel"

export const PLATFORMS = [
  MACOS, // macos
  LINUX,
  WINDOWS, // windows even on 64b
]

export const antivirusNames = [
  "avast",
  "bitdefender",
  "kaspersky",
  "mcafee",
  "avira",
  "norton",
  "esetsecurity",
  "esetsmartsecurity",
  "windowsdefender",
  "pandasecurity",
  "malwarebytes",
  "trendmicro",
  "sophos",
]
